<template>
  <div class="step-indicator">
    <InitialAvatarIcon v-if="isCompleted" icon="EF0070" class="step-indicator__completed" size="medium" />
    <BadgeCounterFoundation v-else :value="icon || 0" :disabled="isDisabled" class="step-indicator__badge" />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  InitialAvatarIcon,
  BadgeCounterFoundation
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

@Component({
  name: 'StepIndicator',
  components: {
    InitialAvatarIcon,
    BadgeCounterFoundation
  }
})
export default class StepIndicator extends Vue {
  public readonly NebraskaColors = NebraskaColors;

  @Prop({ type: Number, required: false })
  public icon?: number;

  @Prop({ type: Boolean, default: false })
  public isCompleted!: boolean;

  @Prop({ type: Boolean, default: false })
  public isDisabled!: boolean;
}
</script>

<style lang="less" scoped>
.step-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  &__completed {
    color: @status-positive;
    background-color: @status-positive-background;
  }
}
</style>
